import { createContext } from 'use-context-selector'
import { OrganizationMembersContextProps } from './types'

export const OrganizationMembersContext = createContext(
  {} as OrganizationMembersContextProps
)
